var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAvatarClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 12C14 13.1046 13.1046 14 12 14C10.8954 14 10 13.1046 10 12C10 10.8954 10.8954 10 12 10C13.1046 10 14 10.8954 14 12ZM10.6 12C10.6 12.7732 11.2268 13.4 12 13.4C12.7732 13.4 13.4 12.7732 13.4 12C13.4 11.2268 12.7732 10.6 12 10.6C11.2268 10.6 10.6 11.2268 10.6 12Z",
    fill: "#002A69"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 12V11",
    stroke: "#002A69",
    strokeWidth: 0.4,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 12L12.5 12.5",
    stroke: "#002A69",
    strokeWidth: 0.4,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8 2C9.38071 2 10.5 3.11929 10.5 4.5C10.5 5.88071 9.38071 7 8 7C6.61929 7 5.5 5.88071 5.5 4.5C5.5 3.11929 6.61929 2 8 2Z",
    fill: "#002A69"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.99983 8C9.2637 8.00003 10.4878 8.3671 11.5184 9.03809C10.0905 9.26855 8.99983 10.5071 8.99983 12C8.99983 12.7694 9.29207 13.469 9.76838 14H3.82502C2.67249 13.9998 1.70591 13.0807 2.08283 12.0371C2.39001 11.1872 2.89577 10.4059 3.57209 9.75781C4.74639 8.63265 6.33915 8 7.99983 8Z",
    fill: "#002A69"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatarClock);
export default __webpack_public_path__ + "static/media/Avatar_clock.6ecdbe5daf2929f2a854ca19a4b8a4cb.svg";
export { ForwardRef as ReactComponent };